import { PRODUCTION, DEVELOPMENT, LOCAL_INTEL_URL } from "./const";
import { isEmpty } from "lodash";

export function intelUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const INTEL_URL = !!process.env.REACT_APP_INTEL_URL && process.env.REACT_APP_INTEL_URL !== "" ? process.env.REACT_APP_INTEL_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_INTEL_URL;
      case PRODUCTION:
        return INTEL_URL;
      default:
        return LOCAL_INTEL_URL;
    }
  } else {
    return LOCAL_INTEL_URL;
  }
}

export const getIntelUrl = () => {
  return `${intelUrl()}`;
};
